// extracted by mini-css-extract-plugin
module.exports = {"login-screen":"Login_login-screen__3H8zs","login-container":"Login_login-container__3wgpm","form":"Login_form__CEhVC","form-control":"Login_form-control__2Ftjg"};